import { mutateProjectTypes } from '../../mutations/mutateProjectTypes';
import { organizationAPI } from 'api/phases/endpoints';
import { serialize } from 'object-to-formdata';

export const addProjectType = async (name: string) => {
  const formData = serialize({ project_type: { name } });
  await organizationAPI.addProjectType(formData);
  await mutateProjectTypes();
};
